import { LOG_IN, LOG_OUT, ME, UPDATE } from '../actions/user/actionTypes';
import CLEAR_ERROR from '../actions/global/actionTypes';
import { get } from '../utils/localStorage';

const defaultState = {
  user: get('user') || {},
  profile: {},
  isFetching: false,
  error: {},
};

const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${LOG_IN}_REQUEST`:
      return { ...state, isFetching: true, error: {}, user: {} };
    case `${LOG_IN}_SUCCESS`:
      return { ...state, isFetching: false, user: action.user };
    case `${ME}_SUCCESS`:
      return { ...state, isFetching: false, profile: action.user, user: action.user };
    case `${UPDATE}_SUCCESS`:
      return { ...state, isFetching: false };
    case `${ME}_REQUEST`:
    case `${UPDATE}_REQUEST`:
    case `${LOG_OUT}_REQUEST`:
      return { ...state, isFetching: true, error: {} };
    case `${LOG_OUT}_SUCCESS`:
      return defaultState;
    case `${LOG_OUT}_ERROR`:
    case `${LOG_IN}_ERROR`:
    case `${ME}_ERROR`:
    case `${UPDATE}_ERROR`:
      return { ...state, isFetching: false, error: action.error };
    case CLEAR_ERROR:
      return { ...state, error: {} };
    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/user.js